// Captures marketing/attribution query params from the landing URL and
// carries them through onboarding until they're sent to the API at
// registration (GFB-1380). Stored in localStorage rather than
// sessionStorage, since a visitor may click an ad, browse, and not
// finish signing up until a later tab/session (e.g. via the
// confirm-email link).
const STORAGE_KEY = "gfb_utm_params"

// Only these four are captured -- they map 1:1 to custom HubSpot
// contact properties of the same names.
const UTM_PARAM_KEYS = ["utm_campaign", "utm_medium", "utm_source", "utm_term"]

// Call once at app boot. Overwrites the stored set whenever the current
// URL carries any of these params (the most recent tagged visit wins);
// leaves whatever's already stored untouched on pages with no query
// string, so it survives navigation through the rest of onboarding.
export function captureUtmParams(search = window.location.search) {
  try {
    const params = new URLSearchParams(search)
    const utmParams = {}
    for (const key of UTM_PARAM_KEYS) {
      const value = params.get(key)
      if (value) {
        utmParams[key] = value
      }
    }
    if (Object.keys(utmParams).length > 0) {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(utmParams))
    }
  } catch (error) {
    // Storage may be unavailable -- attribution is best-effort.
  }
}

export function getStoredUtmParams() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    const parsed = raw ? JSON.parse(raw) : {}
    return parsed && typeof parsed === "object" ? parsed : {}
  } catch (error) {
    return {}
  }
}

// localStorage.clear() that keeps the stored params. Used where a
// logged-out or expired session is wiped on the way to /login, so the
// attribution survives until the user signs up or finishes their profile
// (GFB-1438).
export function clearLocalStorageKeepingUtmParams() {
  try {
    const stored = localStorage.getItem(STORAGE_KEY)
    localStorage.clear()
    if (stored) {
      localStorage.setItem(STORAGE_KEY, stored)
    }
  } catch (error) {
    // Storage may be unavailable -- attribution is best-effort.
  }
}

// Called once the params have been sent to the API at registration --
// the backend owns them (on the user record) from that point until the
// HubSpot contact is created, per GFB-1380.
export function clearStoredUtmParams() {
  try {
    localStorage.removeItem(STORAGE_KEY)
  } catch (error) {
    // ignore
  }
}
